import { IsDateString, IsOptional, IsString } from 'class-validator';

export class GetAppointmentsCountDto {
  @IsOptional()
  @IsDateString()
  fromDate: string;

  @IsOptional()
  @IsDateString()
  toDate: string;

  @IsOptional()
  @IsString()
  org: string;
}

export class GetTasksCountDto {
  @IsOptional()
  @IsDateString()
  fromDate: string;

  @IsOptional()
  @IsDateString()
  toDate: string;

  @IsOptional()
  @IsString()
  org: string;
}

/**
 * Codes returned by the hosted billing-portal endpoint so callers can branch on
 * the reason instead of matching on the message text.
 */
export const BILLING_PORTAL_ERROR_CODES = {
  /** The patient has no processor-side customer yet, i.e. has never purchased. */
  accountMissing: 'BILLING_ACCOUNT_MISSING',
  /** The org's processor has no hosted portal (NMI). */
  unsupported: 'BILLING_PORTAL_UNSUPPORTED'
} as const;
